import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import Page from '../../components/page';
import * as CONST from '../../common/const';
import './index.less'
import moment from 'moment';

const defaultSingle = moment().format('YYYY-MM-DD');

//获取设备的具体保养信息
const PageModel = props => {
	const [info, setInfo] = useState();
	const getData = async (id) => {
		if (!id) return;
		const result = await Request.get({
			url: `/equipmentupkeepInfo`,
			data: { id }
		});
		if (!result) return;
		setInfo(result.data);
	};

	useEffect(() => {
		const { id } = props.match.params;
		if(id){
			getData(id);//查看设备的保养详情---一般查询最后一条保养记录
			// getList({page:'0',id});//获取设备信号列表
		}
		
	}, [123]);
	return (
		<Page {...{ page: 'alleuipment', showFooter: false, title: '运行情况' }} {...props}>
			<section className="deatil-upkeep-container">
				<div className="deatil-header">
					<div className="deatil-header-left">企业名称</div>
					<div className="deatil-header-right">{info && info.enterpriseName}</div>
				</div>
				<div className="deatil-header">
					<div className="deatil-header-left">店铺名称</div>
					<div className="deatil-header-right">{info && info.companyName}</div>
				</div>
				<div className="deatil-header">
					<div className="deatil-header-left">公司地址</div>
					<div className="deatil-header-right">{info && info.address}</div>
				</div>
				<div className="deatil-header">
					<div className="deatil-header-left">所属区域</div>
					<div className="deatil-header-right">{info && info.areaName}</div>
				</div>
				<div className="deatil-header">
					<div className="deatil-header-left">营业状态</div>
					<div className="deatil-header-right">{info && info.status}</div>
				</div>
				<div className="deatil-header">
					<div className="deatil-header-left">设备状态</div>
					<div className="deatil-header-right">
						{info && info.equipmentStatus ==0 ? '正常' : '故障'}
					</div>
				</div>
				<div className="deatil-header">
					<div className="deatil-header-left">保养时间</div>
					<div className="deatil-header-right">{info && info.createdAt ? info.createdAt : (info && info.useTime ? info.useTime + 'h/' + info.equipmentUpkeepTime+'h' : '')}</div>
				</div>
				<div className="deatil-header">
					<div className="deatil-header-left">保养项目</div>
					<div className="deatil-header-right">{info && info.equipmentType == 1 ? '油烟净化器保养' : '风机保养'}</div>
				</div>
				<div className='deatil-photo'>店铺门脸照</div>
				<div className='deatil-photo-container'>
					{
						info && info.companyfile && <img src={CONST.imgPrefix + info.companyfile} alt="" />
					}
					{
						info && !info.companyfile && <label>暂无照片</label>
					}
				</div>
				<div className='deatil-photo'>保养照片</div>
				<div className='deatil-photo-container'>
					{
						info && info.upfile && info.upfile.split(',').length > 0 && info.upfile.split(',').map((item,index) => {
							return (
								<img key={index} src={CONST.imgPrefix +item} alt="" />
							)
						})
					}
				</div>
				
			</section>
		</Page>
	);
};

export default PageModel;
